import React, { ReactNode } from 'react';
import { Stack, StackSpace } from '@grubhubprod/gh-cookbook-react/dist';
import { useScreenSizes } from 'src/utilities/useScreenSizes';

interface IPageHeaderProps {
  children: ReactNode;
  y?: StackSpace;
}

export const PageHeader: React.FC<IPageHeaderProps> = ({ children, y }) => {
  const { isDesktop } = useScreenSizes();
  const deviceY = isDesktop ? 'lg' : 'md';

  return (
    <Stack y={y || deviceY} as="header">
      {children}
    </Stack>
  );
};
